import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(_error: Error, _errorInfo: ErrorInfo) {
        // Error already captured in state via getDerivedStateFromError
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
                    <Typography variant="h4" color="error" gutterBottom>
                        Něco se pokazilo
                    </Typography>
                    <Typography variant="body1" color="text.secondary" paragraph>
                        Aplikace narazila na neočekávanou chybu.
                    </Typography>
                    <Box mt={3}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleReload}
                        >
                            Obnovit stránku
                        </Button>
                    </Box>
                    {process.env.NODE_ENV === 'development' && this.state.error && (
                        <Box mt={4} textAlign="left">
                            <Typography variant="caption" color="error" component="pre" sx={{ whiteSpace: 'pre-wrap' }}>
                                {this.state.error.message}
                                {'\n'}
                                {this.state.error.stack}
                            </Typography>
                        </Box>
                    )}
                </Container>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
